<template>
    <div class="generalframezz">
        <div class="generalcontent" :style="{width:mywidth+'px',height:myheight+'px'}">
            <div :style="{height:myTitleheight+'px',lineHeight:myTitleheight+'px'}" class="general_title">
                <div class="general_title_left">
                    <img :style="{display:tishihide==true?'inline-block':'none'}" class="timgtishi" src="../verificationOriginal/images/ty_tishi.png" alt='版权登记'/>
                    <div>证书核验</div>
                </div>
                <img @click="parentHandleclick()" class="timgclose" src="../verificationOriginal/images/ty_close.png" alt='版权登记'/>
            </div>
            <div class="verify-code">
                <p class="p16">{{p16}}</p>
                <p class="p14">{{p14}}</p>
                <p><input v-model="code" class="text-input" type="text"  :placeholder="placeHolde"  /></p>
                <button @click="getVerifyCode" class="verifybtn">验证</button>
            </div>
           
        </div>
    </div>
</template>

<script>
import { _getVerifyCode,_getByEvidenceArchiveCertNumber} from "@/api/wallet.js";
    export default {
        /*******************写这个会导致非首页进入时title不正确*******************/
        // metaInfo: {
        //     title: '证书核验|版权服务专家|前海版权公共服务平台',
        //     meta: [{                 // set meta
        //         name: 'keyWords',
        //         content: '版权服务,版权百科,版权,前海版权公共服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
        //     },{
        //         name: 'Description',
        //         content: '证书核验,人人都是创作者，人人都是版权人。前海版权公共服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
        //     }]
        // },
        /********************************************************************/

        name:'verifyCode',
        props:{
            mywidth:{
                type:String,
                default:'420'
            },
            myheight:{
                type:String,
                default:'368'
            },
            myTitleheight:{
                type:String,
                default:'85'
            },
            tishihide:{
                type:Boolean,
                default:true
            },
            flag:{
               type:String,
               default:"" 
            },
            orderSeqNo:{
               type:String,
               default:"" 
            },
            showIndex:{
               type:String,
               default:"" 
            }
        },
        data(){
            return{
              code:"" ,
              p16:'可在个人中心-我的存证、我的取证列表下载证书',
              p14:'证书编号可在证书顶部找到',
              placeHolde:'请输入证书编号进行核验'
            }
        },
        methods:{
            parentHandleclick() {
                this.$emit('fatherModal');
                this.code="";
            },
            getVerifyCode(){
                if(this.code){
                    if(this.showIndex=='0'){
                        _getByEvidenceArchiveCertNumber({evidenceArchiveCertNumber:this.code}).then(res => {
                            if(res.code==200){
                                this.$emit('fatherModal');
                                let routeUrl = this.$router.resolve({
                                    path: "/index/creation_verification",
                                    name:'creationVerification',
                                    params: {type:res.result.businessType,id:res.result.orderSeqNo}
                                });
                                window.open(routeUrl.href, '_blank');
                                //this.$router.push({name:'creationVerification',params: {type:res.result.businessType,id:res.result.orderSeqNo}})
                            }else{
                                toast(res.message)
                            }                                                   
                        });
                    }else{
                        const data ={
                            businessType:this.flag,
                            orderSeqNo:this.orderSeqNo,
                            verifyCode:this.code
                        }
                        _getVerifyCode(data).then(res => {
                            if(res.code==200){
                                this.$emit('fatherModal');
                                this.$router.push({name:'creationVerification',params: {type:this.flag,id:this.orderSeqNo}})
                            }else{
                                toast(res.message)
                            }                                                   
                        });
                    }
                }else{
                    toast(this.p16)
                }
                               
            }
        },   
        created() {
            if(this.showIndex=='0'){
                // this.p16='请输入证书编号查看';
                this. p14='证书编号可在证书顶部找到';
                this.placeHolde='请输入证书编号进行核验';
            }else{
                // this.p16='请输入核验码查看';
                this. p14='核验码可在证书底部找到';
                this.placeHolde='请输入核验码进行核验';
            }
        },               
    }
</script>

<style scoped lang="less">
   .generalframezz{
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        margin: auto;
        z-index: 558;
        .generalcontent{
            background:#fff;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            border-radius:8px;
            .general_title{
                border-bottom:1px solid rgba(236,236,236,1);
                font-size:16px;
                font-weight:400;
                color:rgba(50,50,50,1);
                display:flex;
                justify-content: space-between;
                padding:0 30px;
                align-items: center;
                .general_title_left{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .timgtishi{
                    width:25px;
                    height:25px;
                    margin-right:10px;
                }
                .timgclose{
                    width:18px;
                    height:18px;
                    cursor: pointer;
                }
            }
            .verify-code{
                width:420px;
                height:282px;
                background:rgba(252,252,252,1);
                border-radius:0px 0px 8px 8px;
                text-align: center;
                overflow: hidden;
                .p16{
                    font-size:16px;
                    color:rgba(50,50,50,1);
                    line-height:22px;
                    margin:27px 0 5px;
                }
                .p14{
                    font-size:14px;
                    color:rgba(136,136,136,1);
                    line-height:20px;
                }
                .text-input{
                    width:250px;
                    height:45px;
                    outline: none;
                    background:rgba(255,255,255,1);
                    border-radius:4px;
                    border:1px solid rgba(222,226,230,1);
                    text-indent: 15px;
                    margin:39px 0 51px;
                }
                .verifybtn{
                    width:150px;
                    height:37px;
                    line-height: 37px;
                    border:0;
                    background:rgba(255,216,0,1);
                    border-radius:21px;
                    outline: none;
                    font-size:14px;
                    font-weight:600;
                    color:rgba(78,78,78,1);
                    cursor: pointer;
                }
            }
        }
    }
</style>